import { render, staticRenderFns } from "./sort_fields.vue?vue&type=template&id=0a5d69e2&"
import script from "./sort_fields.vue?vue&type=script&lang=js&"
export * from "./sort_fields.vue?vue&type=script&lang=js&"
import style0 from "./sort_fields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports